<template>
  <div>
    <div class="box">
      <admin-form-item label="자동 크롤링 사용여부">
        <lp-radio :val.sync="management.auto_crawling"
                  @onSelect="clickAuto"
                  value_name="value"
                  label_name="label"
                  :data="[{label:'사용 안 함', value:false}, {label:'사용함',value:true}]"></lp-radio>
      </admin-form-item>
      <admin-form-item label="환율">
        <div class="flex-align" style="width:30%">
          <input class="input"
                 step="0.01"
                 type="number" v-model="price">
          <button class="button is-primary" style="width:80px;margin-left:6px" @click="saveData">입력</button>
        </div>
      </admin-form-item>
    </div>
    <div class="box">
      <table class="table">
      <thead>
      <tr>
        <th>index</th>
        <th>생성일</th>
        <th>구분</th>
        <th>금액</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, idx) in list" :key="`item-${idx}`">
        <td>{{ item.index }}</td>
        <td>{{ item.created_time }}</td>
        <td>{{ item.type===0?'직접입력':'크롤링' }}</td>
        <td>{{ item.price }}</td>
      </tr>
      </tbody>
    </table>
    </div>
    <pagination ref="pagination" :total_page="total_page" @change="getData"></pagination>
  </div>
</template>
<script>
  import Pagination from "../../module/common/Pagination";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpRadio from "../../module/common/LpRadio";
  export default {
    name: "ExchangeRate",
    components: {LpRadio, LpCheckBool, Pagination},
    created() {
      this.getData(1)
      this.getAuto();
    },
    data() {
      return {
        list: [],
        total_page: 1,
        price: '',
        management: {
          auto_crawling: true
        }
      }
    },
    methods: {
      getAuto() {
        this.$axios.get('admin/shipagency/exchange_management', this.management.auto_crawling).then(res=>{
          this.management = res.data
        })
      },
      clickAuto() {
        this.$axios.post('admin/shipagency/exchange_management', this.management).then(res=>{
          this.toast('변경되었습니다.');
        })
      },
      saveData() {
        this.$axios.post('admin/shipagency/exchange_rate', {
          price: this.price
        }).then(res=>{
          this.toast('등록되었습니다.');
          this.getData(1);
        })
      },
      getData(num) {
        this.$axios.get(`admin/shipagency/exchange_rate?page_num=${num}&page_length=10`).then(res=>{
          this.list = res.data.data;
          this.total_page = res.data.total_page;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
